/**
 * Shared criticality configuration matching the task classification icons
 * used in facilities/asset-register (diamond, circle, triangle).
 */
export const CRITICALITY_LEVELS = {
    red: { label: "Red", icon: "bi:diamond-fill", color: "#e50f16", rank: 3 },
    amber: { label: "Amber", icon: "fluent:circle-24-filled", color: "#fc6a03", rank: 2 },
    green: { label: "Green", icon: "fluent:triangle-down-12-filled", color: "#228B22", rank: 1 },
}

export const CRITICALITY_NOT_SET = { label: "Not Set", icon: "mdi:circle-outline", color: "text.disabled", rank: 0 }

export const CRITICALITY_OPTIONS = [
    { value: null, ...CRITICALITY_NOT_SET },
    { value: "red", ...CRITICALITY_LEVELS.red },
    { value: "amber", ...CRITICALITY_LEVELS.amber },
    { value: "green", ...CRITICALITY_LEVELS.green },
]

/**
 * Returns the numeric sort rank for a criticality value.
 * red=3, amber=2, green=1, null/undefined=0.
 */
export function criticalityRank(criticality) {
    return CRITICALITY_LEVELS[criticality]?.rank ?? 0
}
